import widgetInfo from './widgetInfo';

const root = { widgetInfo };

export default root;
